/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AssertionErrorTelemetryDetails
 */
export interface AssertionErrorTelemetryDetails {
    /**
     * 
     * @type {string}
     * @memberof AssertionErrorTelemetryDetails
     */
    'type'?: AssertionErrorTelemetryDetailsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AssertionErrorTelemetryDetails
     */
    'message': string;
}

export const AssertionErrorTelemetryDetailsTypeEnum = {
    AssertionError: 'assertionError'
} as const;

export type AssertionErrorTelemetryDetailsTypeEnum = typeof AssertionErrorTelemetryDetailsTypeEnum[keyof typeof AssertionErrorTelemetryDetailsTypeEnum];


